import styled from '@emotion/styled';
import { BREAKPOINTS_LEGACY, COLORS, RADIUSES, TYPOGRAPHY } from '@sortlist-frontend/design-system/legacy';

export const Header = styled.header`
  padding-bottom: 14rem;
`;

export const Title = styled.h1`
  font-size: 4rem;

  @media only screen and (max-width: ${BREAKPOINTS_LEGACY.xs}) {
    font-size: 3rem;
  }
`;

export const StickyBlock = styled.div`
  top: 2rem;
`;

export const Gradient = styled.div`
  pointer-events: none;

  &:after {
    content: '';
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    position: absolute;
    border-radius: ${RADIUSES.md};
    background: linear-gradient(
      180deg,
      rgba(250, 250, 250, 0) 0%,
      rgba(250, 250, 250, 0) 75%,
      rgba(250, 250, 250, 1) 100%
    );
  }
`;

export const ScrollingArea = styled.div`
  max-height: 20rem;
  pointer-events: auto;
`;

export const Section = styled.div`
  table {
    border: collapse;
    border: 1px solid ${COLORS.SECONDARY_300};
  }
  th {
    vertical-align: top;
    white-space: nowrap;
  }
  th,
  td {
    font-size: ${TYPOGRAPHY.SMALL};
    padding: 0.5rem;
    text-align: left;
    border: 1px solid ${COLORS.SECONDARY_300};
  }
  a {
    text-decoration: underline;
    word-break: break-all;
  }
  p {
    margin-bottom: 1rem;
  }
`;

export type IndexProps = {
  selected?: boolean;
};

export const IndexItem = styled.div`
  ${(props: IndexProps) => `
  color: ${props.selected ? COLORS.PRIMARY_500 : COLORS.SECONDARY_900};
  background-color: ${props.selected ? COLORS.PRIMARY_100 : 'transparent'};

  &:hover {
    color: ${COLORS.PRIMARY_500};
    background-color: ${COLORS.PRIMARY_100};
    svg {
      color: ${COLORS.PRIMARY_500};
    }
  }
`}
`;
